import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TireRepairIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tire_repair"}/>
}
